import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import zhTranslation from './locales/zh/translation.json';
import enTranslation from './locales/en/translation.json';

const resources = {
  zh: {
    translation: zhTranslation,
  },
  'zh-CN': {
    translation: zhTranslation,
  },
  'zh-Hans': {
    translation: zhTranslation,
  },
  en: {
    translation: enTranslation,
  },
};

const supportedLanguages = ['zh', 'zh-CN', 'zh-Hans', 'en'];
const queryLanguage = new URLSearchParams(window.location.search).get('lng');
const initialLanguage = supportedLanguages.includes(queryLanguage)
  ? queryLanguage
  : 'zh-CN';

try {
  localStorage.setItem('i18nextLng', initialLanguage);
} catch (error) {
  // Ignore storage restrictions in private browsing or embedded webviews.
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: 'zh',
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: process.env.NODE_ENV === 'development',
    detection: {
      order: ['querystring'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      caches: [],
    },

    interpolation: {
      escapeValue: false,
    },
    resources,
  });

export default i18n;
